"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.NodeTypeSchema = exports.NodeConfigSchema = exports.IntermediateNodeSchema = exports.IntermediateNodeConfigSchema = exports.artifactType = void 0;
const zod_1 = require("zod");
const finley_types_1 = require("@finley-technologies/finley-types");
const tape_builder_base_1 = require("../../types/tape-builder-base");
const types_1 = require("../../uiNodes/tapes/assigned-repayment-tape/types");
exports.artifactType = 'assignedRepaymentTape';
exports.IntermediateNodeConfigSchema = types_1.IntermediateRecordConfigSchema;
// *** Intermediate Record ***
exports.IntermediateNodeSchema = finley_types_1.DbTable.ArtifactWithSlugsSchema.omit({
    configuration: true,
    type: true,
    creditFacilitySlug: true,
    externalFilename: true,
    loanProductSlug: true,
}).extend({
    externalFilename: zod_1.z.null(),
    type: zod_1.z.literal(exports.artifactType),
    loanProductSlug: zod_1.z.string(),
    creditFacilitySlug: zod_1.z.string(),
    configuration: exports.IntermediateNodeConfigSchema,
});
// *** Db Configuration ***
exports.NodeConfigSchema = zod_1.z.object({
    generatedRepaymentTapeArtifactSlug: (0, tape_builder_base_1.zArtifactSlugRef)('Generated repayment tape artifact slug'),
    internalRepaymentTapeArtifactSlug: (0, tape_builder_base_1.zArtifactSlugRef)('Internal repayment tape artifact slug'),
    assignedLoanTapeArtifactSlug: (0, tape_builder_base_1.zArtifactSlugRef)('Assigned loan tape artifact slug'),
});
// *** Db Record ***
exports.NodeTypeSchema = finley_types_1.DbTable.ArtifactWithSlugsSchema.omit({
    configuration: true,
    type: true,
    creditFacilitySlug: true,
    externalFilename: true,
    loanProductSlug: true,
}).extend({
    type: zod_1.z.literal(exports.artifactType),
    creditFacilitySlug: zod_1.z.string(),
    configuration: exports.NodeConfigSchema,
    externalFilename: zod_1.z.null(),
    loanProductSlug: zod_1.z.string(),
});
//# sourceMappingURL=node.js.map